import { Button, Modal, Table, TableProps, Tag } from "antd";
import { useState } from "react";
import { Activity } from "../../entities/interfaces/actviity";

type Props = {
  activities: Activity[];
};

const ActivityList = ({ activities }: Props) => {
  const [modal, setModal] = useState(false);
  const [selected, setSelected] = useState<Activity>();

  const toggleModal = () => {
    setModal(!modal);
  };

  const columns: TableProps<Activity>["columns"] = [
    {
      title: "User",
      key: "user",
      render: (record) => record.user.name,
    },
    {
      title: "Action",
      key: "action",
      render: (record) => {
        switch (record.action) {
          case "UPDATE":
            return <Tag color="orange">{record.action}</Tag>;
          case "DELETE":
            return <Tag color="red">{record.action}</Tag>;
          default:
            return <Tag color="green">{record.action}</Tag>;
        }
      },
    },
    {
      title: "Target",
      dataIndex: "targetType",
      key: "targetType",
    },
    {
      title: "Change",
      key: "Change",
      render: (record) => (
        <Button
          onClick={() => {
            setSelected(record);
            toggleModal();
          }}
        >
          View Changes
        </Button>
      ),
    },
  ];
  const NestedList = ({ data }: any) => {
    return (
      <ul>
        {Object.entries(data).map(([key, value]: any) => (
          <li key={key}>
            {typeof value === "object" && value !== null ? (
              <>
                <strong>{key}:</strong>
                <NestedList data={value} />
              </>
            ) : (
              <>
                <strong>{key}:</strong> {value?.toString()}
              </>
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <>
      <Modal
        open={modal}
        onCancel={toggleModal}
        cancelText="Close"
        okButtonProps={{
          className: "hidden",
        }}
        title="Changes"
      >
        {selected && <NestedList data={selected?.meta} />}
      </Modal>
      <Table dataSource={activities} columns={columns} />
    </>
  );
};

export default ActivityList;
